import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useWedding } from "@/hooks/useWedding";

/**
 * Sends signed-in users without a wedding to onboarding. Partner-invited users
 * already have a wedding doc and pass through. Admin routes are exempt.
 */
export function RequireWedding({ children }: { children: ReactNode }) {
  const { wedding, loading } = useWedding();
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith("/app/admin");

  if (isAdminRoute) {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div
        style={{
          minHeight: "40vh",
          display: "grid",
          placeItems: "center",
          color: "var(--ink-3)",
          fontFamily: "var(--font-mono)",
          fontSize: 12,
        }}
      >
        ●
      </div>
    );
  }

  if (!wedding) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
